const MenuDotsIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      color="currentColor"
    >
      <g
        strokeWidth="1.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4.64961 12.0002H4.66011M11.9996 12.0002H12.0101M19.3496 12.0002H19.3601M5.69961 12.0002C5.69961 12.5801 5.22951 13.0502 4.64961 13.0502C4.06971 13.0502 3.59961 12.5801 3.59961 12.0002C3.59961 11.4203 4.06971 10.9502 4.64961 10.9502C5.22951 10.9502 5.69961 11.4203 5.69961 12.0002ZM13.0496 12.0002C13.0496 12.5801 12.5795 13.0502 11.9996 13.0502C11.4197 13.0502 10.9496 12.5801 10.9496 12.0002C10.9496 11.4203 11.4197 10.9502 11.9996 10.9502C12.5795 10.9502 13.0496 11.4203 13.0496 12.0002ZM20.3996 12.0002C20.3996 12.5801 19.9295 13.0502 19.3496 13.0502C18.7697 13.0502 18.2996 12.5801 18.2996 12.0002C18.2996 11.4203 18.7697 10.9502 19.3496 10.9502C19.9295 10.9502 20.3996 11.4203 20.3996 12.0002Z" />
      </g>
    </svg>
  );
};

export default MenuDotsIcon;
